import { render, staticRenderFns } from "./BaseComponentLoader.vue?vue&type=template&id=0616a67c&scoped=true&"
import script from "./BaseComponentLoader.vue?vue&type=script&lang=js&"
export * from "./BaseComponentLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseComponentLoader.vue?vue&type=style&index=0&id=0616a67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616a67c",
  null
  
)

export default component.exports